import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import specialOptions, { receivedEcheqAction } from "../actionMaker";
import * as config from "../../../util/config";

const FORM_ID = "echeq";

const useActionByEcheckState = (actionsEcheqs, echeq, setDrawer) => {
    const [options, setOptions] = useState([]);
    const dispatch = useDispatch();
    const { environmentCuit } = useSelector((state) => state.echecks);

    const isExpired =
        moment(echeq.fecha_pago)
            .add("days", config.getInteger("echeq.postPayment.daysAllow", 30))
            .isSameOrBefore(moment()) && echeq.estado !== "CADUCADO";

    const echeqActions = (status) => {
        let contextMenuActions = [];

        contextMenuActions = [
            ...contextMenuActions,
            ...specialOptions(echeq, environmentCuit, (action, echeqInfo) =>
                receivedEcheqAction(action, echeqInfo, dispatch, setDrawer),
            ),
        ];
        if (actionsEcheqs[status]) {
            actionsEcheqs[status].forEach((action) => {
                contextMenuActions = [
                    ...contextMenuActions,
                    {
                        label: `${FORM_ID}.${action.toLowerCase()}.echeq`,
                        onClick: () => {
                            receivedEcheqAction(action, echeq, dispatch, setDrawer);
                        },
                    },
                ];
            });
        }

        return contextMenuActions;
    };

    useEffect(() => {
        if (!actionsEcheqs) {
            return;
        }
        const itemsContextMenu = echeqActions(echeq?.estado);
        setOptions(
            itemsContextMenu
                ?.filter((item) => item.label !== "echeq.negotiate.echeq") // Disable the action "DESCONTAR"
                ?.map((item) => ({ text: item.label, func: item.onClick, textType: "I18N" })),
        );
    }, [actionsEcheqs, echeq]);
    return { options, isExpired };
};

export default useActionByEcheckState;
